<script>
/**
 * Mixin for filter (and sorting) options in gw/templates.vue
 */

// Vuex
import { mapState } from 'vuex';
import { GET_TEAMS } from '@/store/mutation-types';
import { FETCH_TEAMS } from '@/store/action-types';

export default {

  computed: {
    gwtOptions() {
      // Filters
      return [
        {
          key: 'gwtOptSelectedTeams',
          component: 'AdvancedTeamPicker',
          value: this.gwtOptSelectedTeams,
          options: {
            useEditableLabel: true,
            displayAllTeams: true,
            disableHigherHierarchy: true,
          },
        },
      ];
    },
    /** Array: IDs ofselected teams */
    gwtOptSelectedTeams() {
      if (this.allPageOptions && this.allPageOptions.gwtOptSelectedTeams) {
        return this.allPageOptions.gwtOptSelectedTeams;
      }
      return [];
    },
    /** If defined, contains all the options above */
    allPageOptions() {
      return null;
    },
    ...mapState({
      gwtOptTeamsLoading: state => state[GET_TEAMS.loadingKey],
    }),
  },

  created() {
    if (this.currentTeam && this.currentTeam.id) {
      // Fetch all teams
      if (!this.gwtOptTeamsLoading) {
        this.$store.dispatch(FETCH_TEAMS);
      }
    }
  },

  methods: {
    /** Create a string formatted as query params with params */
    gwtOptQueryParams(options) {
      if (!options) {
        return '';
      }
      let query = '';
      let amp = '';
      if (options.gwtOptSelectedTeams && options.gwtOptSelectedTeams.length) {
        query += `${amp}gwtOptSelectedTeams=${options.gwtOptSelectedTeams}`;
        amp = '&';
      }
      return query;
    },
  },
};
</script>
